import { REDUCER_NAME } from 'domain/operations/drivers/itineraryStatus/view/constants';
import { getState as getParentState } from 'domain/operations/drivers/itineraryStatus/selectors';

export const getState = (state) => getParentState(state)[REDUCER_NAME];

export const getShipments = (state) => getState(state).shipments;

export const getSummary = (state) => getState(state).summary;

export const getBayan = (state) => getState(state).bayanId;

export const getIsFetching = (state) => getState(state).isFetching;

export const getIsMarkingAsCollected = (state) => getState(state).isMarkingAsCollected;

export const getIsMarkingAsReceived = (state) => getState(state).isMarkingAsReceived;

export const getIsConfirmingCashCollected = (state) => getState(state).isConfirmingCashCollected;

export const getCodCollectionClosed = (state) => getState(state).codCollectionClosed;

export const getWaybillReceivingClosed = (state) => getState(state).waybillReceivingClosed;

export const getIsAttaching = (state) => getState(state).isAttaching;

export const getIsDeattaching = (state) => getState(state).isDeattaching;

export const getIsRearranging = (state) => getState(state).isRearranging;

export const getIsUpdatingRecipient = (state) => getState(state).isUpdatingRecipient;

export const getIsUpdateRecipientScreenOpened = (state) => getState(state).isUpdateRecipientScreenOpened;
